import { createKYCRenewalReducer } from "@repo/redux/kyc-renewal";

// Create reducer with admin-portal specific initial state (12 months ahead)
export default createKYCRenewalReducer(12);
